export default "__VITE_ASSET__Rdc83ne3__"